import { render } from "./InstructionsView.vue?vue&type=template&id=53d41341"
import script from "./InstructionsView.vue?vue&type=script&lang=js"
export * from "./InstructionsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-spiral-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__